import { Module } from 'vuex';
import { ReportsState } from './types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { RootState } from '@/store/types';

const state: ReportsState = {
  reportsStatus: null
};

const namespaced = true;

export const reports: Module<ReportsState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
